import { useEffect, useRef, useState } from 'react';

const WA_LINK = 'https://wa.me/5547984929295?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consulta.';

export default function About() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre" ref={ref} className="py-24 bg-parchment">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <div
            className={`relative transition-all duration-700 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
          >
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-48 h-48 border-2 border-chestnut/20 rounded-lg"></div>
              <div className="relative rounded-lg overflow-hidden h-[520px]">
                <img
                  src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/36402e342f91d2ee22bf2b6cac95c6ef.jpeg"
                  alt="Dra. Leide Gonçalves – Advogada especialista em Direito de Família"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Floating card */}
              <div className="absolute -bottom-6 left-1/2 md:left-auto md:-right-6 bg-ink-black text-white px-4 md:px-6 py-4 md:py-5 rounded-lg w-36 md:w-48 text-center">
                <p className="font-serif text-xl md:text-2xl font-semibold text-burnt-peach">OAB/SC</p>
                <p className="text-xs text-white/60 mt-1 font-sans">Nº 48.826</p>
              </div>
            </div>
          </div>

          {/* Text side */}
          <div
            className={`transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}
          >
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-10 bg-chestnut"></div>
              <span className="text-chestnut text-xs tracking-[0.2em] uppercase font-sans font-medium">Sobre a Advogada</span>
            </div>

            <h2 className="font-serif text-ink-black text-3xl md:text-4xl font-semibold leading-tight mb-6">
              Um olhar humano e estratégico para o seu caso
            </h2>

            <p className="text-body-gray text-base leading-relaxed mb-10 font-sans">
              Leide Gonçalves é advogada especializada em <strong className="text-ink-black">Direito de Família e Sucessões</strong>, com atuação baseada na escuta ativa e na excelência técnica. Orienta clientes em separações, heranças, guarda de filhos e regularização patrimonial — sempre com clareza, ética e humanidade.
            </p>

            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex md:inline-flex items-center justify-center gap-2 bg-burnt-peach hover:bg-burnt-peach-light text-white font-sans font-medium px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap text-sm mx-5 md:mx-0"
            >
              <i className="ri-whatsapp-line text-base"></i>
              Agendar consulta
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
